export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // Video Source Handling
    window.videoSourceSet({
      resize: true,     // Enable recalculating source on resize
      resizeDelay: 100, // Wait for 100ms after resize event before you try calculating
    });

    // Link Handling
    $('a[href$=".pdf"]').click(function openPDF() { open(this.href); return false; });
    $('a.downloadlink').click(function openDownload() { open(this.href); return false; });
    $('a[href^="http"]:not(.fancybox):not(.fancybox-de):not(.fancybox-en):not(.video)').newWin();

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $('.mk__overlay-container').removeClass('active');
      }
    });

    // Touch Class
    if (!("ontouchstart" in document.documentElement)) {
      $('html').addClass('no-touch');
      window.setTimeout(hideMenu, 4200);
      // $('html').addClass('touch');
      // document.documentElement.className += " no-touch";
    } else {
      $('html').addClass('touch');
      // document.documentElement.className += " touch";
    }

    function hideMenu() {
      $('.home .mk__nav').removeClass('active');
      $('.single-projects .mk__nav').removeClass('active');
    }

    function removeCut() {
      $('html').removeClass('cut');
    }

    /* eslint-disable */
    var bLazy = new Blazy({
      selector: '.portrait-lazy',
      successClass: 'lazy-loaded',
      offset: 1000, // Loads images 420px before they're visible
    });

    var mySwiper = new Swiper('.swiper-container', {
      // Optional parameters
      direction: 'horizontal',
      loop: false,
      init: false,
      speed: 900,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },

      effect: 'fade',
    });

    var totalSlides = 0;
    var showHelp = true;

    mySwiper.on('init', function () {
      totalSlides = mySwiper.slides.length - 1;
      console.log('swiper initialized_' + totalSlides);
      bLazy.load($('.swiper-slide-active').find('.swiper-lazy'), true);
      bLazy.load($('.swiper-slide-duplicate-active').find('.swiper-lazy'), true);
      bLazy.load($('.swiper-slide-next').find('.swiper-lazy'), true);
      // bLazy.load($('.swiper-slide-prev').find('.swiper-lazy'), true);
      // Mobile Overlay
      // $('.mk__dot').delay("4200").fadeOut("2000");
      $('.mk__area_prev').addClass('disabled');

      var slideCaption;
      slideCaption = jQuery('.swiper-slide-active .slide-description').html();
      if (!slideCaption) {
        slideCaption = '';
      }
      jQuery('#mk_caption').html(slideCaption);

      var currentSlide = mySwiper.activeIndex;
      if (currentSlide === 0) {
        $('.mk__area_prev').addClass('disabled');
      } else {
        $('.mk__area_prev').removeClass('disabled');
      }
      if (currentSlide === totalSlides) {
        $('.mk__area_next').addClass('disabled');
        $('.mk__area_exit').removeClass('disabled');
        $('#mk__continue_button').addClass('disabled');
        $('#mk__overview_button').removeClass('disabled');
      } else {
        $('.mk__area_next').removeClass('disabled');
        $('.mk__area_exit').addClass('disabled');
        $('#mk__continue_button').removeClass('disabled');
        $('#mk__overview_button').addClass('disabled');
      }
    });

    mySwiper.on('slideChange', function () {
      bLazy.load($('.swiper-slide-active').next().next().find('.swiper-lazy'), true);
      // bLazy.load($('.swiper-slide-active').prev().prev().find('.swiper-lazy'), true);
      jQuery('#mk_caption').html('');

      var currentSlide = mySwiper.activeIndex;
      if (currentSlide === 0) {
        $('.mk__area_prev').addClass('disabled');
        $('.mk__area_prev_exit').removeClass('disabled');
      } else {
        $('.mk__area_prev').removeClass('disabled');
        $('.mk__area_prev_exit').addClass('disabled');
      }
      if (currentSlide === totalSlides) {
        $('.mk__area_next').addClass('disabled');
        $('.mk__area_exit').removeClass('disabled');
        $('#mk__continue_button').addClass('disabled');
        $('#mk__overview_button').removeClass('disabled');
      } else {
        $('.mk__area_next').removeClass('disabled');
        $('.mk__area_exit').addClass('disabled');
        $('#mk__continue_button').removeClass('disabled');
        $('#mk__overview_button').addClass('disabled');
      }
    });
    mySwiper.on('slideChangeTransitionEnd', function () {
      bLazy.load($('.swiper-slide-active').find('.swiper-lazy'), true);
      bLazy.load($('.swiper-slide-duplicate-active').find('.swiper-lazy'), true);
      bLazy.load($('.swiper-slide-active').next().find('.swiper-lazy'), true);
      // bLazy.load($('.swiper-slide-active').prev().find('.swiper-lazy'), true);
      // bLazy.load($('.swiper-slide-duplicate-active').prev().find('.swiper-lazy'), true);

      var slideCaption;
      slideCaption = jQuery('.swiper-slide-active .slide-description').html();
      if (!slideCaption) {
        slideCaption = '';
      }
      // console.log('caption: '+ slideCaption);
      jQuery('#mk_caption').html(slideCaption);

      var currentSlide = mySwiper.activeIndex;
      // console.log('end' + currentSlide);
      if (currentSlide === 0) {
        $('.mk__area_prev').addClass('disabled');
        $('.mk__area_prev_exit').removeClass('disabled');
      } else {
        $('.mk__area_prev').removeClass('disabled');
        $('.mk__area_prev_exit').addClass('disabled');
      }
      if (currentSlide === totalSlides) {
        $('.mk__area_next').addClass('disabled');
        $('.mk__area_exit').removeClass('disabled');
        $('#mk__continue_button').addClass('disabled');
        $('#mk__overview_button').removeClass('disabled');
      } else {
        $('.mk__area_next').removeClass('disabled');
        $('.mk__area_exit').addClass('disabled');
        $('#mk__continue_button').removeClass('disabled');
        $('#mk__overview_button').addClass('disabled');
      }
    });
    mySwiper.init();

    function doOnOrientationChange() {
      switch(window.orientation) {
        case -90:
          // mySwiper.update();
          // bLazy.load($('.swiper-slide-active').find('.swiper-lazy'), true);
          if (showHelp) {
            $('.mk__dot').fadeIn("10").delay("1200").fadeOut("3000");
            showHelp = false;
          }
          break;
        case 90:
          // mySwiper.update();
          // bLazy.load($('.swiper-slide-active').find('.swiper-lazy'), true);
          if (showHelp) {
            $('.mk__dot').fadeIn("10").delay("1200").fadeOut("3000");
            showHelp = false;
          }
          break;
        default:
          break;
      }
    }

    window.addEventListener('orientationchange', doOnOrientationChange);
    doOnOrientationChange();

    $(window).resize(function() {
      bLazy.revalidate(); // this would be like .revalidate() but would also clear any state like the images array
    });


    var scrollPosition;
    var savedScrollPosition;

    window.addEventListener('scroll', function() {
        scrollPosition = window.scrollY;
    });

    window.addEventListener('orientationchange', function(event) {
        if (Math.abs(window.orientation) === 90) {
            savedScrollPosition = scrollPosition;
        } else {
            if (isIOS()) {
                var retryScroll = setInterval(function () {
                    if (window.scrollX === 0 && window.scrollY == savedScrollPosition) {
                        clearInterval(retryScroll);
                    } else {
                        window.scrollTo(0, savedScrollPosition);
                    }
                }, 10 );
            } else {
                window.scrollTo(0, savedScrollPosition);
            }
        }
    });




    /* eslint-enable */

    /* initialize the slider based on the Slider's ID attribute */
    /*
    var revapi = jQuery('#rev_slider_4_1'); // .show().revolution({});

    revapi.bind("revolution.slide.onloaded", function () {


      revapi.bind("revolution.slide.onchange", function (e, data) {


        jQuery('#mk_caption a').removeAttr("style");



      });
    });

        */
    $('.mk__area_prev').click(function mkPrev() { mySwiper.slidePrev(); } );
    $('.mk__area_next').click(function mkNext() { mySwiper.slideNext(); } );
    // $('.mk__area_exit').click(function mkShowOverlay() { $('.mk__overlay-container').addClass('active'); } );
    $('.mk__area_info').click(function mkShowOverlay() { $('.mk__overlay-container').addClass('active'); $('.mk__nav').addClass('hyperactive'); } );

    $('.mk__overlay-container').click(function mkShowOverlay() { $('.mk__overlay-container').addClass('active'); $('.mk__nav').addClass('hyperactive'); } );
    $('.mk__overlay-container').click(function mkHideOverlay() { $('.mk__overlay-container').removeClass('active'); $('html').addClass('cut').find('.mk__nav').removeClass('hyperactive'); window.setTimeout(removeCut, 200); } );
    // $('html').delay(200).removeClass('cut');
    $('.mk__close').click(function mkShowOverlay() { $('.mk__overlay-container').removeClass('active'); $('html').addClass('cut').find('.mk__nav').removeClass('hyperactive'); window.setTimeout(removeCut, 200); } );

    // Prev / Overlay
    $('.mk__area_prev').mouseenter(function () {
      $('#mk__dot').addClass('mk__dot_prev');
    });

    $('.mk__area_prev').mouseleave(function () {
      $('#mk__dot').removeClass('mk__dot_prev');
    });

    // Prev Exit / Overlay
    $('.mk__area_prev_exit').mouseenter(function () {
      $('#mk__dot').addClass('mk__dot_exit');
    });

    $('.mk__area_prev_exit').mouseleave(function () {
      $('#mk__dot').removeClass('mk__dot_exit');
    });

    // Next / Overlay
    $('.mk__area_next').mouseenter(function () {
      $('#mk__dot').addClass('mk__dot_next');
    });

    $('.mk__area_next').mouseleave(function () {
      $('#mk__dot').removeClass('mk__dot_next');
    });

    // Exit
    $('.mk__area_exit').mouseenter(function () {
      $('#mk__dot').addClass('mk__dot_exit');
    });

    $('.mk__area_exit').mouseleave(function () {
      $('#mk__dot').removeClass('mk__dot_exit');
    });

    // Info / Overlay
    $('.mk__area_info').mouseenter(function () {
      $('#mk__dot').addClass('mk__dot_info');
    });

    $('.mk__area_info').mouseleave(function () {
      $('#mk__dot').removeClass('mk__dot_info');
    });

    // Exit / Overlay
    $('.mk__area_exit').mouseenter(function () {
      $('#mk__dot').addClass('mk__dot_exit');
    });

    $('.mk__area_exit').mouseleave(function () {
      $('#mk__dot').removeClass('mk__dot_exit');
    });

    /* eslint-disable */
    (function() {
      var follower, init, mouseX, mouseY, positionElement, printout, timer;

      follower = document.getElementById('mk__follower');

      mouseX = (event) => {
        return event.clientX;
      };

      mouseY = (event) => {
        return event.clientY;
      };

      positionElement = (event) => {
        var mouse;
        mouse = {
          x: mouseX(event) - 31,
          y: mouseY(event) - 31,
        };
        follower.style.top = mouse.y + 'px';
        return follower.style.left = mouse.x + 'px';
      };

      timer = false;

      window.onmousemove = init = (event) => {
        var _event;
        _event = event;
        return timer = setTimeout(() => {
          return positionElement(_event);
        }, 1);
      };

    }).call(this);
    /* eslint-enable */
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js